import { ButtonLink, LogoTypeBrand } from '../../components'

interface LandingFooterBrandSectionProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export const LandingFooterBrandSection = ({
  className = '',
  size = 'md',
}: LandingFooterBrandSectionProps) => {
  const sizeConfig = {
    sm: { width: 'w-[80px]', height: 'h-6' },
    md: { width: 'w-[100px]', height: 'h-8' },
    lg: { width: 'w-[120px]', height: 'h-10' },
  }

  const config = sizeConfig[size]

  return (
    <div
      className={`${config.width} ${config.height} relative flex items-center justify-center ${className}`}
    >
      <ButtonLink href='/'>
        <LogoTypeBrand
          alt='logo'
          fill
          sizes={config.width}
          priority
          className='object-contain h-auto'
        />
      </ButtonLink>
    </div>
  )
}
